import { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../services/authService';
import './ForgotPassword.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await requestPasswordReset(email);
        } catch (_) {
            // intentionally ignored — always show the same message
        } finally {
            setLoading(false);
            setSubmitted(true);
        }
    };

    return (
        <div className="forgot-page">
            <div className="forgot-form">
                <h2>Obnovení hesla</h2>
                {submitted ? (
                    <p className="forgot-success">
                        Pokud je tento email registrován, obdržíte odkaz pro obnovení hesla.
                    </p>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="email">Email</label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="email"
                        />
                        <button type="submit" disabled={loading}>
                            {loading ? 'Odesílám...' : 'Odeslat odkaz'}
                        </button>
                    </form>
                )}
                <p className="forgot-link">
                    <Link to="/login">Zpět na přihlášení</Link>
                </p>
            </div>
        </div>
    );
}

export default ForgotPassword;
